'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Provides a object with functions to create a share for various
 * social services.
 * @module shareActionFactory
 *
 * @author Kaspar Manz <kaspar.manz@tages-anzeiger.ch>
 */

/**
 * Create a URL to share an object on twitter.
 *
 * @param {Object} parameters
 * @param {string} parameters.url URL to share
 * @param {string=} parameters.title Description or title to be prefilled as
 * text.
 * @param {string=} parameters.via The Twitter handle that should be
 * prefilled as «via».
 * @param {Array.string=} parameters.hashtags The hashtags that the tweet
 * should prefill.
 * @returns {string} The action URL that opens the Twitter share screen.
 * @throws {TypeError} if url is missing.
 */
function twitterShareUrl(parameters) {
  var title = parameters.title,
      url = parameters.url,
      via = parameters.via,
      hashtags = parameters.hashtags;


  if (url === undefined) {
    throw new TypeError('[Share URL Factory] URL not defined');
  }

  // Basic URL
  var shareUrl = 'https://twitter.com/intent/tweet';

  // Add URL
  // We assume that there is always a URL present.
  // This might bite us in our posteriors at some future time.
  shareUrl += '?url=' + encodeURIComponent(url);

  // Add title or additional text
  if (title) {
    shareUrl += '&text=' + encodeURIComponent(title);
  }

  // Add via
  if (via) {
    shareUrl += '&via=' + encodeURIComponent(via);
  }

  // Add hashtags
  if (hashtags) {
    shareUrl += '&hashtags=' + encodeURIComponent(hashtags.join(','));
  }

  return shareUrl;
}

/**
 * Create an URL to share an object on Facebook.
 *
 * @param {Object} parameters
 * @param {string} parameters.url The URL to be shared.
 * @param {number} parameters.facebook_id The Facebook App ID.
 * @param {Array.string=} parameters.hashtags The hashtags to share the
 * content with. Similar to Twitter, but here only the first object is
 * taken, so place your hashtags wisely!
 * @returns {string} The URL with which the Facebook share dialog is being
 * opened.
 * @throws {TypeError} if url or facebook_id is undefined.
 */
function facebookShareUrl(parameters) {
  var url = parameters.url,
      hashtags = parameters.hashtags,
      facebook_id = parameters.facebook_id;


  if (url === undefined) {
    throw new TypeError('[Share URL Factory] URL not defined');
  }

  if (facebook_id === undefined) {
    throw new TypeError('[Share URL Factory] Facebook ID not defined.');
  }

  var shareUrl = 'https://www.facebook.com/dialog/share';

  shareUrl += '?display=popup';

  shareUrl += '&app_id=' + facebook_id;

  // Basic URL
  shareUrl += '&href=' + encodeURIComponent(url);
  shareUrl += '&redirect_uri=' + encodeURIComponent(url);

  // Add hashtags
  if (hashtags) {
    shareUrl += '&hashtag=' + encodeURIComponent('#' + hashtags[0]);
  }

  return shareUrl;
}

exports.default = {
  /**
   * @function twitter
   * @public
   */
  twitter: twitterShareUrl,
  /**
   * @function facebook
   * @public
   */
  facebook: facebookShareUrl
};


//////////////////
// WEBPACK FOOTER
// ./~/ta-js-toolbox/dist/shareActionFactory.js
// module id = 129
// module chunks = 0